<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
    <div class="add-prescription-page">
      <b-card>
        <img class="logo" v-if="user.brand_logo" :src="user.brand_logo" />
        <img class="logo" v-else src="@/assets/images/logo.png" />
      </b-card>
      <b-card>
       
        <template v-if="success">
            <center>
              <br /> <br /> 
                <img width="40" src="@/assets/images/valid.svg" /><br /><br />
              <p>Your prescription has been uploaded.
               </p>
                
            <p class="text-muted mb-3">
              Your prescription is currently being analyzed. You can now get back to the main screen to continue your purchasing experience.
            </p>
            </center>
        </template>
        <template v-else>
          <div v-if="display_upload_buttons==false" class="button-back" @click="returnButton"><img src="@/assets/images/arrow.svg" width="18" /></div>
          <div class="title">Upload your prescription</div>
          <template v-if="display_upload_buttons==true">
            <input
            ref="cameraCaptureInput"
            type="file"
            accept="image/*"
            capture="environment"
            class="d-none"
            @change="onFileChosen"
            >
            <input
            ref="filePickerInput"
            type="file"
            accept=".jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf"
            class="d-none"
            @change="onFileChosen"
            >
          
            <b-row class="mb-1">
            <b-col
                v-if="showMobileCaptureButton"
                cols="12"
                md="4"
                class="mb-1"
            >
                <b-button
                variant="secondary"
              
                @click="$refs.cameraCaptureInput.click()"
                >
                <img src="@/assets/images/photo.svg" width="18" />
                Take a photo
                </b-button>
            </b-col>
            <b-col
                v-if="showDesktopCameraButton"
                cols="12"
                md="4"
                class="mb-1"
            >
                <b-button
                variant="secondary"
                
                @click="openCameraModal"
                >
                <img src="@/assets/images/photo.svg" width="18" />
                Take a photo
                </b-button>
            </b-col>
            <b-col cols="12" md="4" class="mb-1">
                <b-button
                variant="primary"
                
                @click="$refs.filePickerInput.click()"
                >
                <img src="@/assets/images/upload.svg" width="14" />
                Choose file
                </b-button>
            </b-col>
            </b-row>

            <p class="text-muted mb-3">
              Supports photos (JPG, PNG, WebP) and PDF, handwritten and printed prescriptions are both accepted.
            </p>

          </template>
            <div v-if="previewUrl" class="preview-zone mb-3">
            <img
                v-if="previewKind === 'image'"
                :src="previewUrl"
                alt="Aperçu"
                class="preview-img"
            >
            <div v-else class="pdf-badge">
                <span class="pdf-label">selected PDF</span>
                <small class="text-muted d-block">{{ selectedFileName }}</small>
            </div>
            </div>

            <b-button
            v-if="fileBase64 && !submitting"
            variant="secondary"
          
            @click="submitPrescription"
            >
            Send prescription
            </b-button>
        </template>
      </b-card>
    </div>

    <b-modal
      id="camera-modal"
      v-model="cameraModalShow"
      title="Capture photo"
      ok-title="Capture"
      cancel-title="Close"
      @ok="captureFromCamera"
      @shown="startCamera"
      @hidden="stopCamera"
    >
      <video
        ref="videoEl"
        autoplay
        playsinline
        muted
        class="camera-video w-100"
      />
      <canvas ref="canvasEl" class="d-none" />
      <p class="text-muted small mt-2 mb-0">
        Grant camera access if browser ask it
      </p>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BButton,
  BOverlay,
  BRow,
  BCol,
  BCard,
  BModal,
} from 'bootstrap-vue'
import { APIRequest,Auth } from '@simb2s/senseye-sdk'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BButton,
    BRow,
    BCol,
    BModal,
  },
  data() {
    return {
      prescription: null,
      display_upload_buttons: true,
      loading: true,
      submitting: false,
      fileBase64: null,
      success:false,
      user: null,
      previewUrl: null,
      previewKind: 'image',
      selectedFileName: '',
      cameraModalShow: false,
      stream: null,
    }
  },

  computed: {
    /** Téléphone / tablette : input natif avec capture. Bureau : flux webcam (modal). */
    isMobileLikeCameraDevice() {
      if (typeof navigator === 'undefined') return false
      const ua = navigator.userAgent || ''
      if (/Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(ua)) return true
      if (/iPad|Tablet|Silk/i.test(ua)) return true
      if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true
      return false
    },
    showMobileCaptureButton() {
      return this.isMobileLikeCameraDevice
    },
    showDesktopCameraButton() {
      return !this.isMobileLikeCameraDevice
    },
   
  },

  async mounted() {
    
    if(this.$route.params.token)
    {
   
      localStorage.token_senseye_auth=this.$route.params.token
      await this.getUser()
    }
    try {
      this.prescription = await APIRequest.update(
        'prescriptions',
        this.$route.params.id,
        { status: 'processing' },
      )
    } catch (e) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          text: 'Impossible to load prescription.',
          icon: 'AlertCircleIcon',
          variant: 'danger',
        },
      })
    } finally {
      this.loading = false
    }
  },

  beforeDestroy() {
    this.stopCamera()
  },

  methods: {
    returnButton(){
      this.display_upload_buttons=true
      
      this.fileBase64=null
      this.success=false
      this.previewUrl=null
      
    },
    async getUser() {
      let user=this.parseJwt(this.$route.params.token)
      console.log("user",user)
      let user_data=await Auth.get_user(user.username)
      console.log("user_data",user_data)
      this.user=user_data
    },
    parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    },
    isAllowedFile(file) {
      const allowedMime = ['image/jpeg', 'image/png', 'application/pdf']
      const nameOk = /\.(jpe?g|png|pdf)$/i.test(file.name || '')
      const mimeOk = file.type && allowedMime.includes(file.type)
      return mimeOk || (nameOk && (!file.type || file.type === ''))
    },

    clearHiddenInputs() {
      if (this.$refs.cameraCaptureInput) {
        this.$refs.cameraCaptureInput.value = ''
      }
      if (this.$refs.filePickerInput) {
        this.$refs.filePickerInput.value = ''
      }
    },

    onFileChosen(event) {
      const file = event.target.files && event.target.files[0]
      this.clearHiddenInputs()
      if (!file) return

      if (!this.isAllowedFile(file)) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Format not available',
            text: 'Please use JPG, PNG or PDF.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
        return
      }
      this.display_upload_buttons=false
      this.selectedFileName = file.name
      const reader = new FileReader()
      reader.onload = () => {
        const { result } = reader
        this.fileBase64 = result
        if (typeof result === 'string' && result.startsWith('data:image')) {
          this.previewKind = 'image'
          this.previewUrl = result
        } else if (typeof result === 'string' && result.startsWith('data:application/pdf')) {
          this.previewKind = 'pdf'
          this.previewUrl = result
        } else {
          this.previewKind = 'image'
          this.previewUrl = result
        }
      }
      reader.readAsDataURL(file)
    },

    openCameraModal() {
      this.cameraModalShow = true
    },

    async startCamera() {
      this.stopCamera()
      try {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          throw new Error('Camera not available in this browser.')
        }
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
          audio: false,
        })
        await this.$nextTick()
        if (this.$refs.videoEl) {
          this.$refs.videoEl.srcObject = this.stream
        }
      } catch (e) {
        this.cameraModalShow = false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Camera',
            text: e.message || 'Impossible to access camera.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      }
    },

    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(t => t.stop())
        this.stream = null
      }
      if (this.$refs.videoEl) {
        this.$refs.videoEl.srcObject = null
      }
    },

    captureFromCamera(bvModalEvt) {
      const video = this.$refs.videoEl
      const canvas = this.$refs.canvasEl
      if (!video || !canvas || !video.videoWidth) {
        bvModalEvt.preventDefault()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Camera',
            text: 'The cam is not ready, please wait.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        return
      }
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(video, 0, 0)
      const dataUrl = canvas.toDataURL('image/jpeg', 0.92)
      this.fileBase64 = dataUrl
      this.previewKind = 'image'
      this.previewUrl = dataUrl
      this.selectedFileName = 'photo.jpg'
      console.log('okk')
      this.display_upload_buttons=false
    },

    async submitPrescription() {
      if (!this.fileBase64) return
      this.submitting = true
      this.loading = true
      try {
        this.prescription = await APIRequest.update(
          'prescriptions',
          this.$route.params.id,
          {
            file: this.fileBase64,
            status: 'received',
          },
        )
        this.success=true
       
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erreur',
            text: (err && err.message) || 'Impossible to send. Retry.',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.submitting = false
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn 
{
  display:flex;
  align-items: center;
  flex:1;
  width:100%;
  justify-content: flex-start;
  gap:10px;
}
.title {
  font-size: 25px;

  margin-top:20px;
  margin-bottom: 30px;
}
.logo 
{
  width:150px;
}
.add-prescription-page {
  max-width: 720px;
  margin: 0 auto;
  background:#fff;
  padding-top:50px;
  min-height:100vh;
}
.button-back
{
  width:30px;
  height:30px;
  background:#f1f1f1;
  border-radius:5px;
  display:flex;
  position:absolute;
  top:0;
  left:20px;
  align-items: center;
  justify-content: center;
  cursor:pointer;
  img
  {
    width:8px;
    transform:rotate(180deg);
  }
}
.preview-img {
  max-width: 100%;
  max-height: 280px;
  object-fit: contain;
  border-radius: 0.25rem;
  border: 1px solid #dee2e6;
}

.preview-zone {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 0.25rem;
}

.pdf-badge {
  padding: 1rem;
}

.camera-video {
  max-height: 360px;
  background: #000;
  border-radius: 0.25rem;
}
</style>
